export const LOGIC_COL = {
  ITEM_NAME: 'item_name',
  STORE_NAME: 'store_name',
  ITEM_CATEGORY: 'item_category',
  CHANNEL: 'channel',
  COLUMN: 'columns',
  GENDER: 'gender',
  SELLER_ADDRESS: 'seller_address',
  UNIT_PRICE: 'unit_price',
  AMOUNT: 'amount',
  BIRTH_YEAR: 'birth_year'
}
const { ITEM_NAME, STORE_NAME, ITEM_CATEGORY, CHANNEL, COLUMN, GENDER, SELLER_ADDRESS, UNIT_PRICE, AMOUNT, BIRTH_YEAR } = LOGIC_COL

const operator = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
  EQUAL: 'Equal',
  NOT_EQUAL: 'NotEqual',
  GT: 'Gt',
  GTE: 'Gte',
  LT: 'Lt',
  LTE: 'Lte'
}
const { INCLUDE, EXCLUDE, EQUAL, NOT_EQUAL, GT, GTE, LT, LTE } = operator
const INT_OPERATOR = [EQUAL, NOT_EQUAL, GT, GTE, LT, LTE]

export const optionConf = {
  [ITEM_NAME]: { value: ITEM_NAME, label: 'item name', operator: [INCLUDE, EXCLUDE] },
  [STORE_NAME]: { value: STORE_NAME, label: 'store name', operator: [INCLUDE, EXCLUDE] },
  [ITEM_CATEGORY]: { value: ITEM_CATEGORY, label: 'item category', useSelector: true, multipleSelection: true, operator: [INCLUDE, EXCLUDE] },
  [CHANNEL]: { value: CHANNEL, label: 'channel', useSelector: true, multipleSelection: true, operator: [INCLUDE, EXCLUDE] },
  [COLUMN]: { value: COLUMN, label: 'columns', useSelector: true, multipleSelection: true, operator: [INCLUDE, EXCLUDE] },
  [GENDER]: { value: GENDER, label: 'gender', useSelector: true, multipleSelection: true, operator: [INCLUDE] },
  [SELLER_ADDRESS]: { value: SELLER_ADDRESS, useSelector: true, multipleSelection: true, label: 'seller address', operator: [INCLUDE] },
  [UNIT_PRICE]: { value: UNIT_PRICE, label: 'unit price', operator: INT_OPERATOR },
  [AMOUNT]: { value: AMOUNT, label: 'amount', operator: INT_OPERATOR },
  [BIRTH_YEAR]: { value: BIRTH_YEAR, label: 'birth year', operator: INT_OPERATOR }
}

export const invoiceLogicColOptions = [ITEM_NAME, STORE_NAME, ITEM_CATEGORY, CHANNEL, COLUMN]

export const audienceLogicColOptions = [ITEM_CATEGORY, ITEM_NAME, CHANNEL, STORE_NAME, GENDER, SELLER_ADDRESS, UNIT_PRICE, AMOUNT, BIRTH_YEAR]
